import { useMemo } from 'react';
import { ReloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import useQueryParamsContext from '@/contexts/query-params/useQueryParamsContext';
import { isModifiedFromDefaults } from '@/utils/formUtils';

export default function ClearAllFiltersButton({
  label,
  onReset,
  defaultParams,
}) {
  const { queryParams } = useQueryParamsContext();

  const isDisabled = useMemo(() => {
    return !isModifiedFromDefaults(queryParams, defaultParams);
  }, [defaultParams, queryParams]);

  return (
    <Button
      type="default"
      className="btn-primary-reverse h-8"
      icon={<ReloadOutlined />}
      onClick={onReset}
      disabled={!isDisabled}
    >
      <span>{label}</span>
    </Button>
  );
}
